<template>
  <div v-if="loaded" class="text-center d-flex">
    <div class="px-2">
      <BaseSinglePie title="Заданий" color="teal" :max-value="allCount" :value="allCount" />
    </div>
    <div class="px-2">
      <BaseSinglePie title="Выполнено" color="green" :max-value="allCount" :value="completedCount" />
    </div>
    <div class="px-2">
      <BaseSinglePie title="Не выполнено" color="red" :max-value="allCount" :value="uncompletedCount" />
    </div>
  </div>
</template>

<script>
import BaseSinglePie from "@/components/charts/BaseSinglePie.vue";

export default {
  name: "TasksReport",
  components: { BaseSinglePie },

  data() {
    return {
      loaded: false,
      allCount: 0,
      completedCount: 0,
      uncompletedCount: 0,
    };
  },

  async created() {
    await this.load();
  },

  mounted() {
    // Слушает добавление новой группы заданий из темплейта и релоадим список
    this.$bus.$on("addNewTaskGroup", this.listenAddGroupTask);
    this.$bus.$on("TASK_LIST_UPDATE", this.listenAddGroupTask);
  },

  destroyed() {
    this.$bus.$off("addNewTaskGroup", this.listenAddGroupTask);
    this.$bus.$off("TASK_LIST_UPDATE", this.listenAddGroupTask);
  },

  methods: {
    async load() {
      try {
        const { data } = await this.$http.get(`/v1/customers/${this.$store.state.customer.id}/scheduled-events/reports`);

        this.allCount = data.tasks_count;
        this.completedCount = data.tasks_completed_count;
        this.uncompletedCount = data.tasks_uncompleted_count;

        this.loaded = true;
      } catch (e) {
        console.log("e");
      }
    },

    listenAddGroupTask() {
      this.load();
    },
  },
};
</script>

<style scoped></style>
